/**
 * @generated SignedSource<<2d08ff9b598a895e28826ab7f974695c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SplitRuleInputObject = {
  accountIdsA?: ReadonlyArray<string> | null | undefined;
  accountIdsB?: ReadonlyArray<string> | null | undefined;
  endDateA?: any | null | undefined;
  endDateB?: any | null | undefined;
  regexA?: string | null | undefined;
  regexB?: string | null | undefined;
  ruleId: string;
  selectedTxnIds?: ReadonlyArray<string> | null | undefined;
  startDateA?: any | null | undefined;
  startDateB?: any | null | undefined;
};
export type ruleDetailPage_SplitRuleMutation$variables = {
  input: SplitRuleInputObject;
};
export type ruleDetailPage_SplitRuleMutation$data = {
  readonly splitRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rules: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_SplitRuleMutation = {
  response: ruleDetailPage_SplitRuleMutation$data;
  variables: ruleDetailPage_SplitRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rules",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_SplitRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitRuleMutationPayload",
        "kind": "LinkedField",
        "name": "splitRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_SplitRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SplitRuleMutationPayload",
        "kind": "LinkedField",
        "name": "splitRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ce4d14f1b87e1b0355608a0a3850cca",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_SplitRuleMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_SplitRuleMutation(\n  $input: SplitRuleInputObject!\n) {\n  splitRule(input: $input) {\n    rules {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd8447310e4372b16ae4c6963c21a055";

export default node;
